// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.index__rotateBase--kPjOX {
    transition:0.3s !important;
}

.index__rotate90--PKLET {
    transform:rotate(90deg);
}

.index__rotate180--xvGVP {
    transform:rotate(180deg);
}

@-webkit-keyframes index__rotating--CIMlF /* Safari and Chrome */ {
    from {
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(-360deg);
      -o-transform: rotate(-360deg);
      transform: rotate(-360deg);
    }
  }
  @keyframes index__rotating--CIMlF {
    from {
      -ms-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -ms-transform: rotate(-360deg);
      -moz-transform: rotate(-360deg);
      -webkit-transform: rotate(-360deg);
      -o-transform: rotate(-360deg);
      transform: rotate(-360deg);
    }
  }

.index__rotateLoopAnimationBaseTime--ASZiE {
    animation: index__rotating--CIMlF 0.5s linear infinite;
}`, "",{"version":3,"sources":["webpack://./src/Components/RotateClass/index.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI;MACE,+BAA+B;MAC/B,0BAA0B;MAC1B,uBAAuB;IACzB;IACA;MACE,kCAAkC;MAClC,6BAA6B;MAC7B,0BAA0B;IAC5B;EACF;EACA;IACE;MACE,2BAA2B;MAC3B,4BAA4B;MAC5B,+BAA+B;MAC/B,0BAA0B;MAC1B,uBAAuB;IACzB;IACA;MACE,8BAA8B;MAC9B,+BAA+B;MAC/B,kCAAkC;MAClC,6BAA6B;MAC7B,0BAA0B;IAC5B;EACF;;AAEF;IACI,sDAAwC;AAC5C","sourcesContent":[".rotateBase {\r\n    transition:0.3s !important;\r\n}\r\n\r\n.rotate90 {\r\n    transform:rotate(90deg);\r\n}\r\n\r\n.rotate180 {\r\n    transform:rotate(180deg);\r\n}\r\n\r\n@-webkit-keyframes rotating /* Safari and Chrome */ {\r\n    from {\r\n      -webkit-transform: rotate(0deg);\r\n      -o-transform: rotate(0deg);\r\n      transform: rotate(0deg);\r\n    }\r\n    to {\r\n      -webkit-transform: rotate(-360deg);\r\n      -o-transform: rotate(-360deg);\r\n      transform: rotate(-360deg);\r\n    }\r\n  }\r\n  @keyframes rotating {\r\n    from {\r\n      -ms-transform: rotate(0deg);\r\n      -moz-transform: rotate(0deg);\r\n      -webkit-transform: rotate(0deg);\r\n      -o-transform: rotate(0deg);\r\n      transform: rotate(0deg);\r\n    }\r\n    to {\r\n      -ms-transform: rotate(-360deg);\r\n      -moz-transform: rotate(-360deg);\r\n      -webkit-transform: rotate(-360deg);\r\n      -o-transform: rotate(-360deg);\r\n      transform: rotate(-360deg);\r\n    }\r\n  }\r\n\r\n.rotateLoopAnimationBaseTime {\r\n    animation: rotating 0.5s linear infinite;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rotateBase": `index__rotateBase--kPjOX`,
	"rotate90": `index__rotate90--PKLET`,
	"rotate180": `index__rotate180--xvGVP`,
	"rotateLoopAnimationBaseTime": `index__rotateLoopAnimationBaseTime--ASZiE`,
	"rotating": `index__rotating--CIMlF`
};
export default ___CSS_LOADER_EXPORT___;
